<ng-container *ngIf="previewSettings?.streamUrls">
    <ng-container *ngIf="previewSettings.isVideo">
        <div class="media-wrapper video">
            <video
                #mediaRef
                class="media-element"
                style="max-height: 250px"
                appAspectRatio
                (aspectRatioChange)="onAspectRatioChange($event)"
                [src]="previewSettings.streamUrls.uploadUrl"
                [muted]="previewSettings.toMute"
                [class.flip-horizontally]="previewSettings.toFlipHorizontal"
                playsinline
                preload="auto"
                (loadedmetadata)="onLoadedMetadata($event, 'here')"
                (timeupdate)="onTimeUpdate()"
                (ended)="onVideoEnded()"></video>

            <div
                *ngIf="previewSettings.toDisplayControls"
                class="controls-container"
                [class.column-layout]="!isHorizontalControls">
                <button mat-icon-button (click)="togglePlayMedia()">
                    <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
                </button>

                <div class="time-display">{{ currentTime | timeFormat }} / {{ duration | timeFormat }}</div>

                <app-scrub-bar
                    [duration]="duration"
                    [currentTime]="currentTime"
                    [currentTimeInSeconds]="currentTime / 1000"
                    [navigateFromEditRoom]="false"
                    (newSeekInMillisEmitter)="emitNewTime($event)">
                </app-scrub-bar>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!previewSettings.isVideo">
        <div class="media-wrapper audio">
            <audio
                #mediaRef
                preload="auto"
                [muted]="previewSettings.toMute"
                [src]="previewSettings.streamUrls.uploadUrl"
                (loadedmetadata)="onLoadedMetadata($event, 'there')"
                (timeupdate)="onTimeUpdate()"></audio>

            <div *ngIf="previewSettings.toDisplayControls" class="controls-container">
                <button mat-icon-button (click)="togglePlayMedia()">
                    <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
                </button>

                <div class="time-display">{{ currentTime | timeFormat }} / {{ duration | timeFormat }}</div>

                <app-scrub-bar
                    [duration]="duration"
                    [currentTime]="currentTime"
                    [currentTimeInSeconds]="currentTime / 1000"
                    [navigateFromEditRoom]="false"
                    (newSeekInMillisEmitter)="emitNewTime($event)">
                </app-scrub-bar>
            </div>
        </div>
    </ng-container>
</ng-container>
